import { useNavigate } from 'react-router-dom';
import { Sparkles, X } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';

export default function PaywallDialog({ open, onOpenChange, feature, required, balance }) {
  const navigate = useNavigate();
  const { credits } = useAuth();
  const cur = balance ?? credits ?? 0;

  const featureLabels = {
    qa_ask: 'Ask AI',
    styling_analyze: 'AI Styling analysis',
    regimen_generate: 'Regimen generation',
  };
  const label = featureLabels[feature] || 'this AI feature';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-card border-border/70 rounded-2xl max-w-md"
        data-testid="paywall-dialog"
      >
        <DialogHeader>
          <div className="mx-auto h-12 w-12 rounded-full bg-rose-tint/60 border border-rose-tint flex items-center justify-center">
            <Sparkles className="h-5 w-5 text-rose-gold" />
          </div>
          <DialogTitle className="font-display text-2xl text-center text-ink">
            Out of credits
          </DialogTitle>
          <DialogDescription className="text-center text-sm text-muted-foreground">
            You need <span className="font-semibold text-ink">{required ?? 1}</span> credit
            {(required ?? 1) === 1 ? '' : 's'} to use {label}.
            <br />
            Your balance:{' '}
            <span className="font-semibold text-ink tabular-nums" data-testid="paywall-balance">
              {cur}
            </span>{' '}
            credit{cur === 1 ? '' : 's'}.
          </DialogDescription>
        </DialogHeader>
        <div className="rounded-xl bg-cream-paper border border-border/70 p-4 text-sm text-foreground/80 leading-relaxed">
          Purchase credits to keep using AI Q&amp;A, Styling and Regimen features.
          <ul className="mt-2 text-xs text-muted-foreground space-y-1">
            <li>• Ask AI — 1 credit / question</li>
            <li>• AI Styling — 2 credits / analysis</li>
            <li>• Regimen — 2 credits / generation</li>
          </ul>
        </div>
        <DialogFooter className="flex-col sm:flex-row gap-2 sm:gap-2">
          <Button
            variant="outline"
            className="rounded-xl w-full sm:w-auto"
            onClick={() => onOpenChange(false)}
            data-testid="paywall-cancel-button"
          >
            <X className="h-4 w-4 mr-1" /> Maybe later
          </Button>
          <Button
            className="rounded-xl bg-primary text-primary-foreground hover:bg-primary/90 w-full sm:w-auto"
            onClick={() => {
              onOpenChange(false);
              navigate('/credits');
            }}
            data-testid="paywall-buy-button"
          >
            <Sparkles className="h-4 w-4 mr-1" /> Buy credits
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
